/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { toRefs, computed, ref, watchEffect } from '@vue/composition-api';
import { getDefaultFormat, formatTime, parseToDayjs, formatDate, isValidDate } from '../../_common/js/date-picker/format.js';
import { useVModel } from '../../hooks/useVModel.js';
import { extractTimeFormat } from '../../_common/js/date-picker/utils.js';
import 'lodash/isString';
import 'dayjs';
import '../../_chunks/dep-fdafdce0.js';
import '../../_common/js/log/index.js';
import '../../_common/js/log/log.js';
import '@babel/runtime/helpers/objectDestructuringEmpty';
import '@babel/runtime/helpers/extends';
import '@babel/runtime/helpers/defineProperty';
import 'lodash/isFunction';
import '../../_chunks/dep-fdb92d47.js';
import 'lodash/chunk';
import 'lodash/kebabCase';

function useSingleValue(props) {
  var _toRefs = toRefs(props),
    valueFromProps = _toRefs.value;
  var _useVModel = useVModel(valueFromProps, props.defaultValue, props.onChange, "change"),
    _useVModel2 = _slicedToArray(_useVModel, 2),
    value = _useVModel2[0],
    onChange = _useVModel2[1];
  var formatRef = computed(function () {
    return getDefaultFormat({
      mode: props.mode,
      format: props.format,
      enableTimePicker: props.enableTimePicker
    });
  });
  if (props.enableTimePicker) {
    if (!extractTimeFormat(formatRef.value.format)) console.error("format: ".concat(formatRef.value.format, " \u4E0D\u89C4\u8303\uFF0C\u5305\u542B\u65F6\u95F4\u9009\u62E9\u5FC5\u987B\u8981\u6709\u65F6\u95F4\u683C\u5F0F\u5316 HH:mm:ss"));
  }
  var time = ref(formatTime(value.value, formatRef.value.format, formatRef.value.timeFormat, props.defaultTime));
  var month = ref(parseToDayjs(value.value, formatRef.value.format).month());
  var year = ref(parseToDayjs(value.value, formatRef.value.format).year());
  var cacheValue = ref(formatDate(value.value, {
    format: formatRef.value.format
  }));
  watchEffect(function () {
    if (!value.value) {
      cacheValue.value = "";
      return;
    }
    if (!isValidDate(value.value, formatRef.value.format)) return;
    cacheValue.value = formatDate(value.value, {
      format: formatRef.value.format
    });
    time.value = formatTime(value.value, formatRef.value.format, formatRef.value.timeFormat, props.defaultTime);
  });
  return {
    year: year,
    month: month,
    value: value,
    time: time,
    cacheValue: cacheValue,
    onChange: onChange
  };
}

export { useSingleValue as default };
//# sourceMappingURL=useSingleValue.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/date-picker/hooks/useSingleValue.js
// module id = null
// module chunks = 